import { useIsMobile } from '@/hooks/use-mobile'
import FundingRoundsScreenDesktop from './FundingRoundsScreenDesktop'
import FundingRoundsScreenMobile from './FundingRoundsScreenMobile'

const FundingRoundsScreen = () => {
  const isMobile = useIsMobile()

  if (isMobile) {
    return <FundingRoundsScreenMobile />
  }

  return <FundingRoundsScreenDesktop />
}

export default FundingRoundsScreen
